import UseAxios from '../../../Api/http/http';
import { fetchUserInfo } from '../../../Api/request/integration';

// Define the function to fetch user information
export const fetchUserInfoFromZoho = async (fullName) => {
  try {
    const data = {
      filterValues: { fullName: fullName, employeestatus: 'Active' },
      fieldsToShow: [
        'employeeId',
        'fullName',
        'emailId',
        'vertical',
        'employeestatus',
        'photoSignedUrl',
      ],
    };

    const response = await UseAxios(fetchUserInfo(data));

    let users = response?.data?.users?.data || [];

    users = users.sort((ac, bc) => {
      const nameA = ac.fullName.toLowerCase();
      const nameB = bc.fullName.toLowerCase();
      const searchTerm = fullName.toLowerCase();

      // Check if name starts with the search term
      const startsWithA = nameA.startsWith(searchTerm);
      const startsWithB = nameB.startsWith(searchTerm);

      if (startsWithA && !startsWithB) return -1;
      if (!startsWithA && startsWithB) return 1;

      // If both start with the search term or neither does, sort alphabetically
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });

    return users.slice(0, 6); // Return the top 6 sorted results
  } catch (error) {
    console.error('Error fetching user info:', error);
    throw error;
  }
};

export const convertEmployeeStatusToValue = (status) =>
  ({
    Active: 1,
    Resigned: 0,
    Terminated: 0,
    'Early Exit': 0,
  })[status] || '';
